import React from 'react';
import { Check, X } from 'lucide-react';
export const ForWho = () => {
  const yesList = ['Quieres cabello liso sin dañarlo', 'Tu cabello está teñido o decolorado', 'Estas embarazada o lactando', 'Quieres resultados que duren meses', 'Buscas una experiencia capilar completa'];
  const noList = ['Buscas resultados de 100% sin movimiento (alisado extremo con químicos)', 'Prefieres hacer todo en casa sin asesoría profesional', 'Quieres el precio más bajo sin importar la calidad', 'No estás dispuesta a seguir el mantenimiento post-tratamiento'];
  return <section className="pt-4 pb-16 bg-beige-100" data-id="element-230">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
        <h2 className="text-3xl md:text-4xl font-serif text-center text-neutral-900 mb-8" data-id="element-232">
          ¿Para quién es este servicio?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-233">
          {/* YES Column */}
          <div className="bg-white rounded-3xl p-8 shadow-sm border-t-4 border-t-gold-400" data-id="element-234">
            <h3 className="text-2xl font-serif text-neutral-900 mb-6 flex items-center" data-id="element-235">
              <span className="bg-gold-100 text-gold-600 w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm" data-id="element-236">
                ✓
              </span>
              SÍ es para ti si…
            </h3>
            <ul className="space-y-4" data-id="element-237">
              {yesList.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-238">
                  <Check className="w-5 h-5 text-gold-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-239" />
                  <span className="text-neutral-700" data-id="element-240">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* NO Column */}
          <div className="bg-beige-50 rounded-3xl p-8 shadow-sm border border-beige-200" data-id="element-241">
            <h3 className="text-2xl font-serif text-neutral-500 mb-6 flex items-center" data-id="element-242">
              <span className="bg-neutral-200 text-neutral-500 w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm" data-id="element-243">
                ✕
              </span>
              NO es para ti si…
            </h3>
            <ul className="space-y-4" data-id="element-244">
              {noList.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-245">
                  <X className="w-5 h-5 text-neutral-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-246" />
                  <span className="text-neutral-500" data-id="element-247">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
};